import {NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';
import {TypeLocalityLevelEnum} from '@/modules/neodash/model/types/enums/typeLocalityLevelEnum';
import { i18nService } from '@/services';
import { getCountry } from '@/store/util';

const country = getCountry();

export const listAllTypesLocalityLevel = (): NameValues => {
  const nameValues: NameValues = [];

  nameValues.push({ name: i18nService.i18n('Common.IBGE'), value: TypeLocalityLevelEnum.Ibge });
  nameValues.push({ name: i18nService.i18n('Common.Client'), value: TypeLocalityLevelEnum.Client });

  return nameValues;
};
